import { getApiKey } from "../../utils/apiKey";
import React from "react";
import Header from "../header";
import { createGlobalStyle } from "styled-components";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";

class Certificates extends React.Component {
  state = {
    Certificates: null,
    loading: true,
    VendorHeader: true,
  };
  componentDidMount() {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    const Data = { garage_id: localStorage.getItem("garage_id") };
    axios
      .post(`${apiCall_domain}/customer/mechanics/certificates`, Data, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ Certificates: res.data.data, loading: false });
      });
  }
  documents(item) {
    this.props.history.push({
      pathname: "/multiVendor/categoryDetails/Certificates/CertificateImg",
      Certificates: item,
    });
  }
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              title={"گواهینامه ها"}
              VendorHeader={this.state.VendorHeader}
            />
            {this.state.Certificates.map((item) => (
              <div className="CertificatesComMultiVendor">
                <span className="CertificatesName">{item.title}</span>
                <div className="documents">
                  <span onClick={() => this.documents(item)}>مشاهده مدارک</span>
                  <img src="/public/assets/icons/documents.svg" alt="pic" />
                </div>
              </div>
            ))}
          </>
        )}
      </>
    );
  }
}
export default Certificates;
